<template>
	<type-wrapper class="type-Footer" limit>
		<type-grid :row="showData.data.length" margin v-for="(items, index) in showData.data" :key="index">
			<type-content v-hover="{ color: themeColor }" class="pointer" medium left v-if="items.title" @click="items.isShow = !items.isShow">{{ items.title }}</type-content>
			<transition name="slide" appear>
				<div class="type-Footer-block" v-if="items.data.length">
					<type-content left small :key="i" class="pointer" :style="contentColor" @click="jumpAction(item)" v-hover="{ color: themeColor }" v-for="(item, i) in items.data">{{ item.title }}</type-content>
				</div>
			</transition>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// 尾部导航栏
	import mixin from '../mixin.js'
	export default {
		name: 'type-Footer',
		mixins: [ mixin ]
	}
</script>

<style scoped lang="less">
	.type-Footer{
		display: flex;
		flex-wrap: wrap;
		.pointer{
			cursor: pointer;
		}
		.type-Footer-block{
			overflow: hidden;
		}
		.slide-enter-active{
		    opacity: 0;
		    transform: translateY(50%);
		    animation: slide-enter 700ms forwards;
		}
		@keyframes slide-enter{
			from{
				opacity: 0;
				transform: translateY(50%);
			}
			to{
				opacity: 1;
				transform: translateY(0%);
			}
		}
		.slide-leave-active{
			opacity: 1;
			max-height: 500px;
			animation: slide-leave 300ms forwards;
		}
		@keyframes slide-leave{
			from{
				opacity: 1;
				max-height: 500px;
			}
			to{
				opacity: 0;
				max-height: 0;
			}
		}
	}
</style>
